import { toRelativeURL } from '@/components/ActivityViewers/utils/toRelativeURL'
import { log } from '../log'

export const normalizeImageSrcToOrigin = (element: HTMLDivElement, allowedExternalSources: string[]) => {
  if (!element) {
    return
  }

  const images = element.getElementsByTagName('img') as HTMLCollectionOf<HTMLImageElement>

  for (let i = 0, len = images.length; i < len; i++) {
    if (!images[i].src) continue

    try {
      const url = new URL(images[i].src)
      const isInternal = url.origin === window.location.origin

      if (isInternal) {
        continue
      }

      // we need to exclude instructor info image, because it can be external URL
      const isInstructorInfoImage = !!images[i].closest('.instructor-info-image')

      if (isInstructorInfoImage) {
        continue
      }

      const isAllowed = allowedExternalSources.some((source) => {
        const sourceURL = new URL(source)
        return sourceURL.origin === url.origin
      })

      if (isAllowed) {
        continue
      }

      const relativeURL = toRelativeURL(url.href)
      const parsedURL = new URL(relativeURL, window.location.origin)
      images[i].src = parsedURL.href
    } catch (e) {
      console.log(e)
      log('[EditorJS] broken image source', images[i].src)
    }
  }
}
